import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import axios from 'axios';

import Layout from '../../layout/fullpage';
import { Media, MediaGroup, Image, Logo } from '../../components';

function AuthReset() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    const emailFromUrl = searchParams.get('email');
    const tokenFromUrl = searchParams.get('token');
    if (emailFromUrl && tokenFromUrl) {
      setEmail(emailFromUrl);
      setToken(tokenFromUrl);
    } else {
      setError('Invalid reset link.');
    }
  }, [searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!password || !confirm) {
      setError('Please fill in both fields.');
      return;
    }

    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }

    try {
      await axios.post('/Token/reset-password', {
        email,
        token,
        newPassword: password,
      });
      setSuccess('Password reset successful. Redirecting to login...');
      setTimeout(() => navigate('/auths/auth-login'), 3000);
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to reset password.');
    }
  };

  return (
    <Layout title="Reset Password" centered>
      <div className="container p-2 p-sm-4">
        <Card className="overflow-hidden card-gutter-lg rounded-4 card-auth card-auth-mh">
          <Row className="g-0 flex-lg-row-reverse">
            <Col lg="5">
              <Card.Body className="h-100 d-flex flex-column justify-content-center">
                <div className="nk-block-head text-center">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title mb-2">Set a New Password</h3>
                    <p className="small col-md-10 mx-auto">Enter your new password below.</p>
                  </div>
                </div>

                {error && <Alert variant="danger">{error}</Alert>}
                {success && <Alert variant="success">{success}</Alert>}

                <Form onSubmit={handleSubmit}>
                  <Row className="gy-3">
                    <Col className="col-12">
                      <Form.Group>
                        <Form.Label>New Password</Form.Label>
                        <Form.Control
                          type="password"
                          placeholder="Enter new password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col className="col-12">
                      <Form.Group>
                        <Form.Label>Confirm Password</Form.Label>
                        <Form.Control
                          type="password"
                          placeholder="Confirm password"
                          value={confirm}
                          onChange={(e) => setConfirm(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col className="col-12">
                      <div className="d-grid">
                        <Button type="submit">Reset Password</Button>
                      </div>
                    </Col>
                  </Row>
                </Form>

                <div className="text-center mt-4">
                  <p className="small"><Link to="/auths/auth-login">Back to Login</Link></p>
                </div>
              </Card.Body>
            </Col>

            <Col lg="7">
              <Card.Body className="bg-darker is-theme has-mask has-mask-1 h-100 d-flex flex-column justify-content-end">
                <div className="mask mask-1"></div>
                <div className="brand-logo"><Logo /></div>
                <div className="row">
                  <div className="col-sm-11">
                    <div className="mt-4">
                      <div className="h1 title mb-3">Welcome back</div>
                      <p>Set your new password to continue using our services securely.</p>
                    </div>
                  </div>
                </div>
                <div className="mt-5">
                  <MediaGroup className="media-group-overlap">
                    <Media size="sm" shape="circle" border className="border-white"><Image src="/images/avatar/a.jpg" alt="" /></Media>
                    <Media size="sm" shape="circle" border className="border-white"><Image src="/images/avatar/b.jpg" alt="" /></Media>
                    <Media size="sm" shape="circle" border className="border-white"><Image src="/images/avatar/c.jpg" alt="" /></Media>
                    <Media size="sm" shape="circle" border className="border-white"><Image src="/images/avatar/d.jpg" alt="" /></Media>
                  </MediaGroup>
                  <p className="small mt-2">Over 2k people trust us, and counting!</p>
                </div>
              </Card.Body>
            </Col>
          </Row>
        </Card>
      </div>
    </Layout>
  );
}

export default AuthReset;
